import ActionsPage from '../ActionsPage';
import { SwitchSinisters } from './SwitchSinisters';

export const ActionsPageSinisters = () => (
  <ActionsPage title="Consultas de siniestros" switchAction={<SwitchSinisters />} />
);
